import { Injectable, Scope } from '@nestjs/common';
import { instanceToInstance } from 'class-transformer';
import config from 'config';
import Pusher from 'pusher';

import { PusherEventType } from '../enumerations';
import { WinstonLogger } from '../loggers';
import { PusherAuthenticateInputModel, PusherAuthenticateOutputModel, PusherAuthorizeInputModel, PusherAuthorizeOutputModel } from '../models';
import { Request } from '../types';

@Injectable({ scope: Scope.REQUEST })
export class PusherService {
  private readonly options = config.get<any>('pusher');
  private readonly pusher: Pusher | null = null;

  constructor(private readonly winstonLogger: WinstonLogger) {
    this.winstonLogger.setContext(PusherService.name);
    if (!this.options.channel) return;
    this.pusher = new Pusher({ ...this.options, useTLS: true });
  }

  public authenticate({ socket_id }: PusherAuthenticateInputModel, request: Request): PusherAuthenticateOutputModel {
    const response = this.pusher?.authenticateUser(socket_id, { id: request.user?.id }) || { auth: null, user_data: null };
    return instanceToInstance(new PusherAuthenticateOutputModel(response));
  }

  public authorize({ channel_name, socket_id }: PusherAuthorizeInputModel): PusherAuthorizeOutputModel {
    const response = this.pusher?.authorizeChannel(socket_id, channel_name) || { auth: null };
    return instanceToInstance(new PusherAuthorizeOutputModel(response));
  }

  public async emit<T>(data: T, type: PusherEventType, instanceName: string, { id, user }: Request): Promise<T> {
    if (!this.pusher) return data;
    try {
      await this.pusher.trigger(this.options.channel, `${instanceName}.${type}`, { data, id });
      if (user?.id) await this.pusher.sendToUser(user.id, `${instanceName}.${type}`, { data, id });
    } catch (error: any) {
      this.winstonLogger.error(error);
    }
    return data;
  }
}
